import merge from 'lodash/merge'
import type { UseListProps, UseListResult } from '@ztechapps/common.hook'
import { useList } from '@ztechapps/common.hook'
import type { InventoryBySerialNumber } from '@ztechapps/common.contract'
import { inventorybyserialnumberQueries } from './graphql'

export const useInventoryBySerialNumberList = (
  { query, ...props } = {} as Partial<UseListProps>
): UseListResult<InventoryBySerialNumber> => {
  query = query ?? inventorybyserialnumberQueries.allConfig.query

  const defaultProps = {
    limit: 100,
    sort: { createdAt: -1 },
    //we should not put here the local storage, because it is being used by the multiple products,
    // it will cause issue related to product_.id not being filter correctly
  }

  const finalProps = merge(defaultProps, props) as unknown as UseListProps

  finalProps.query = query

  return useList<InventoryBySerialNumber>(finalProps)
}
